import { render } from "./ShipPicture.vue?vue&type=template&id=46306c79&scoped=true"
import script from "./ShipPicture.vue?vue&type=script&lang=js"
export * from "./ShipPicture.vue?vue&type=script&lang=js"

import "./ShipPicture.vue?vue&type=style&index=0&id=46306c79&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46306c79"]])

export default __exports__